import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, xcss } from '@atlaskit/primitives';
import { Card, ElementName, SmartLinkPosition, SmartLinkSize, SmartLinkTheme, TitleBlock } from '../../../../index';
import RelatedLinkItemOld from './RelatedLinkItemOld';
var hoverStyles = xcss({
  ':hover': {
    backgroundColor: 'color.background.input.hovered',
    borderRadius: 'border.radius.100',
    marginInline: 'space.negative.100',
    paddingInline: 'space.100'
  },
  paddingTop: 'space.100',
  paddingBottom: 'space.100',
  gap: 'space.150',
  font: 'font.body.small'
});
var RelatedLinkItem = function RelatedLinkItem(_ref) {
  var url = _ref.url,
    testId = _ref.testId;
  var subtitle = [{
    name: ElementName.Provider,
    hideIcon: true
  }];
  var ui = {
    hideElevation: true,
    hidePadding: true,
    hideBackground: true,
    theme: SmartLinkTheme.Black,
    clickableContainer: true,
    size: SmartLinkSize.Large
  };
  return /*#__PURE__*/React.createElement(Box, {
    testId: testId,
    xcss: hoverStyles
  }, /*#__PURE__*/React.createElement(Card, {
    appearance: "block",
    ui: ui,
    url: url
  }, /*#__PURE__*/React.createElement(TitleBlock, {
    maxLines: 1,
    hideTitleTooltip: true,
    position: SmartLinkPosition.Center,
    subtitle: subtitle,
    anchorTarget: "_blank"
  })));
};
var RelatedLinkItemExported = function RelatedLinkItemExported(props) {
  if (fg('bandicoots-compiled-migration-smartcard')) {
    return /*#__PURE__*/React.createElement(RelatedLinkItem, props);
  } else {
    return /*#__PURE__*/React.createElement(RelatedLinkItemOld, props);
  }
};
export default RelatedLinkItemExported;